/**
 * <s-video-popup> — small floating product video in the bottom corner.
 * Slides in shortly after the page loads, stays for a set time, then hides
 * itself. The close button sends the `--close` command to dismiss it early.
 *
 * Attributes:
 *   data-delay    — ms before it appears (default 1000).
 *   data-duration — ms it stays visible (default 10000).
 */
class SVideoPopup extends HTMLElement {
  #ac;
  #timers = [];

  connectedCallback() {
    this.#ac = new AbortController();
    const delay = Number(this.dataset.delay || 1000);
    const duration = Number(this.dataset.duration || 10000);

    this.#timers.push(setTimeout(() => {
      this.toggleAttribute('data-visible', true);
      this.querySelector('video')?.play?.().catch(() => {});
      this.#timers.push(setTimeout(() => this.#hide(), duration));
    }, delay));

    this.addEventListener('command', (event) => {
      if (event.command === '--close') this.#hide();
    }, { signal: this.#ac.signal });
  }

  #hide() {
    this.removeAttribute('data-visible');
    this.#timers.push(setTimeout(() => {
      this.querySelector('video')?.pause?.();
      this.hidden = true;
    }, 300));
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#timers.forEach(clearTimeout);
  }
}

if (!customElements.get('s-video-popup')) customElements.define('s-video-popup', SVideoPopup);
